import YearlyCalendar from '../../molecules/yearly-calendar'

export type CalendarEventsProps = {
  finSwitchDates?: Date[]
  onUserDatesChange: (dates: Date[]) => void
  userDates?: Date[]
}

const CalendarEvents = ({ finSwitchDates, onUserDatesChange, userDates }: CalendarEventsProps) => (
  <div>
    <div>
      <YearlyCalendar
        editableDates={userDates}
        readonlyDates={finSwitchDates}
        onUserSelection={onUserDatesChange}
      />
    </div>
  </div>
)

export default CalendarEvents
